import { render, staticRenderFns } from "./SeatingChartEditor.vue?vue&type=template&id=3eefff48"
import script from "./SeatingChartEditor.vue?vue&type=script&lang=js"
export * from "./SeatingChartEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports